import "react-app-polyfill/ie11";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.starts-with";

import * as Sentry from "@sentry/browser";
import gfyw from "./controllers/gfyw";
import common from "./controllers/common";
import homepage from "./controllers/homepage";
import error404 from "./controllers/error404";
import section from "./controllers/section";
import gamescreen from "./controllers/gamescreen";
import gamescreenfull from "./controllers/gamescreenfull";

window.jsLoaded = true;

function App() {
	function init() {
		if ($("body").attr("data-section")) {
			_routes($("body").attr("data-section"));
		} else {
			_routes("default");
		}
	}
	function _routes(section) {
		section = section.replace(/-/g, "");
		if (section == "home") {
			section = "homepage";
		}
		window.section = section;

		common();

		if (typeof eval(`_controllers.${section}`) === "function") {
			eval(`_controllers.${section}()`);
		}
	}
	const _controllers = {
		homepage,
		error404,
		section,
		gamescreen,
		gamescreenfull,
		gfyw,
	};
	return {
		init,
	};
}
$(() => {
	Sentry.init({
		// eslint-disable-line no-undef
		dsn: "https://22102f41d5a240819fa17858c90ed5f8@sentry.crna.win/4",
		release: __webpack_hash__, // eslint-disable-line no-undef
		whitelistUrls: [
			/[www|dev|next.]*juegosjuegos\..*/,
			/[www.]*pomu\..*/,
			/[www.]*jogosjogos\..*/,
		],
		ignoreErrors: [
			"Network Error",
			"AbortError: The operation was aborted.",
			"from accessing a frame with origin",
			"pktAnnotationHighlighter",
			/NS_ERROR.*/,
			"top.GLOBALS",
			"trackEvent is not defined",
			/.+SetVariable.+/,
			/.+HTMLIFrameElement.+/,
			/.+chrome.loadTimes().+/,
			"play() failed because the user didn't interact with the document first.",
			/.+Symbol.+/,
		],
		shouldSendCallback() {
			return (
				window.navigator.userAgent.indexOf("Opera Mini") != -1 &&
				!(
					window.navigator.userAgent.indexOf("Firefox") == -1 &&
					parseInt(window.navigator.userAgent.split("Firefox/")[1], 10) < 57
				)
			);
		},
		environment:
			window.location.href.toString().indexOf("dev.") !== -1
				? "development"
				: "production",
	}); // eslint-disable-line no-undef
	new App().init();
});
